import { PowerGuardBase } from './PowerGuard.gen';
/** @public */
class PowerGuard extends PowerGuardBase { }
export { PowerGuard };